import React, { useEffect, useState, useMemo } from "react";
import FrameworkContent from "./frameworkContent";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import file from "../../../../images/File.png";
import fileVerticle from "../../../../images/FileVerticle.png";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function FrameworksDialog(props) {
  const subContentData = [
    {
      id: 0,
      image1: file,
      image2: fileVerticle,
      selected: false,
      templateType: "template_1",
      flipImage: false,
      topic: "Sustainability Report Format",
      content:
        "This is will generate a sustainability reporting format which catalogue all the reporting metrics under various ESG categories on the system",
    },
    {
      id: 1,
      image1: file,
      image2: fileVerticle,
      selected: false,
      templateType: "template_2",
      flipImage: false,
      topic: "Framework Prescribed format",
      content:
        "This will generate the report in format as prescribed by the reporting framework you have chosen.",
    },
  ];

  const [title, setTitle] = useState(false);
  const [titleName, setTitleName] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const [contentId, setContentId] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [defaultFilter, setDefaultFilter] = useState("");
  const [template, setTemplate] = useState("");
  const [subContent, setSubContent] = React.useState(subContentData);

  // Filter frameworks based on search query
  const filteredFramework = useMemo(() => {
    if (!searchQuery.trim()) {
      return props.framework;
    }

    const query = searchQuery.toLowerCase();
    const filtered = {
      mandatory_data: [],
      recommended_data: [],
      others_data: [],
    };

    // Filter each category
    Object.keys(props.framework).forEach((key) => {
      if (filtered.hasOwnProperty(key)) {
        filtered[key] = props.framework[key].filter((framework) =>
          framework.framework_name?.toLowerCase().includes(query)
        );
      }
    });

    return filtered;
  }, [props.framework, searchQuery]);

  const states = {
    subContentData,
    contentId,
    setContentId,
    selectedIndex,
    setSelectedIndex,
    defaultFilter,
    setDefaultFilter,
    template,
    setTemplate,
    subContent,
    setSubContent,
  };

  // Reset search when dialog opens
  useEffect(() => {
    if (props.open) {
      setSearchQuery("");
    }
  }, [props.open]);

  function handleTitle(content, i) {
    setTitle((preValue) => !preValue);
    setTitleName(typeof content === "object" && content.framework_name);
    if (
      content.template_type !== undefined &&
      content.template_type.template_2
    ) {
      if (props.template === "template_1") {
        setSelectedIndex(0);
        setTemplate("template_1");
      } else if (props.template === "template_2") {
        setSelectedIndex(1);
        setTemplate("template_2");
      }
    } else {
      if (props.template === "template_1" || props.template === "template_2") {
        setSelectedIndex(0);
        setTemplate("template_1");
      }
    }
  }

  return (
    <Dialog
      open={props.open}
      TransitionComponent={Transition}
      keepMounted
      PaperProps={{
        sx: {
          width: "680px",
          minHeight: "500px",
          maxHeight: "80vh",
        },
      }}
    >
      <Grid container>
        <Grid
          item
          sm={11}
          md={11}
          lg={11}
          sx={{
            display: "flex",
            marginTop: "10px",
            marginLeft: "auto",
            marginRight: "auto",
            width: "80%",
          }}
        >
          {title && (
            <ArrowBackIcon
              onClick={() => setTitle((preValue) => !preValue)}
              sx={{
                margin: "10px",
                cursor: "pointer",
              }}
            />
          )}
          <Grid container>
            <Typography
              variant="body1"
              sx={{
                fontWeight: "600",
                margin: "10px",
              }}
            >
              {title ? titleName : "Frameworks"}
            </Typography>
          </Grid>
          <Grid>
            {!title && (
              <CloseIcon
                name="closeFramwork"
                sx={{
                  cursor: "pointer",
                  margin: "5px",
                  color: "#3374B9",
                }}
                onClick={() => {
                  props.setOpen(false);
                  setSearchQuery("");
                }}
              />
            )}
          </Grid>
        </Grid>
      </Grid>

      {/* Search Field - only show when not in title mode */}
      {!title && (
        <Grid container justifyContent="center" sx={{ marginTop: "10px" }}>
          <Grid item sm={11} md={11} lg={11}>
            <TextField
              fullWidth
              size="small"
              placeholder="Search frameworks..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: "#666" }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                },
              }}
            />
          </Grid>
        </Grid>
      )}

      {!title &&
        Object.keys(filteredFramework).map((key, index) => {

          return (
            filteredFramework[key].length > 0 && (
              <React.Fragment key={index}>
                <Grid container justifyContent="center">
                  <Grid
                    item
                    sm={11}
                    md={11}
                    lg={11}
                    sx={{
                      borderBottom: "1px solid #BBBBBB",
                      padding: "16px 8px",
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: "600",
                        color: "#6C6C6C",
                      }}
                    >
                      {key === "mandatory_data"
                        ? "National Frameworks"
                        : key === "recommended_data"
                          ? "Region specific framework"
                          : "International frameworks"}
                    </Typography>
                  </Grid>
                </Grid>
                <DialogContent sx={{ minWidth: "615px", maxWidth: "650px" }}>
                  <FrameworkContent
                    {...props}
                    states={states}
                    framework={filteredFramework[key]}
                    setOpen={props.setOpen}
                    open={props.open}
                    onClose={props.onClose}
                    subContent={props.subContent}
                    handleTitle={handleTitle}
                    title={title}
                    template={props.template}
                  />
                </DialogContent>
              </React.Fragment>
            )
          );
        })}

      {/* No results message */}
      {!title && searchQuery.trim() !== "" &&
        Object.values(filteredFramework).every((arr) => arr.length === 0) && (
          <Grid container justifyContent="center" sx={{ marginTop: "30px" }}>
            <Grid item sm={11} md={11} lg={11} sx={{ textAlign: "center" }}>
              <Typography variant="body1" sx={{ color: "#666" }}>
                No frameworks found matching "{searchQuery}"
              </Typography>
            </Grid>
          </Grid>
        )}

      {title && (
        <DialogContent sx={{ minWidth: "602px", maxWidth: "650px" }}>
          <FrameworkContent
            {...props}
            states={states}
            framework={props.framework}
            setOpen={props.setOpen}
            open={props.open}
            onClose={props.onClose}
            subContent={props.subContent}
            handleTitle={handleTitle}
            title={title}
            template={props.template}
          />
        </DialogContent>
      )}
    </Dialog>
  );
}

export default React.memo(FrameworksDialog);
